const links = [
  { label: 'Media', href: 'https://media.smallsmall.com/' },
  {
    label: 'Knowledge base',
    href: 'https://help.smallsmall.com/SmallSmall/directories.',
  },
  { label: 'FAQ', href: 'https://help.smallsmall.com/SmallSmall/directories' },
];

function AboutBanner() {
  return (
    <section className=" md:mt-5 mt-16 bg-[#FFDE11] md:pt-20 pt-20 pb-9 md:pb-4  px-10 md:px-0">
      <div className="flex md:flex-row flex-col">
        <div className="flex items-center flex-col md:order-1 order-last">
          {/* <div className="md:w-full flex justify-start"> */}
          <img src="/images/login-img.svg" alt="" className="w-1/2" />
          {/* </div> */}
          {/* Bottom links */}
          <div className="flex  items-center justify-start gap-4  md:pt-3">
            <div className="mx-auto md:mx-0 flex items-center justify-center gap-1">
              {links.map((l, i) => (
                <a
                  key={i}
                  href={l.href}
                  className="  px-3 py-1 text-xs md:text-sm font-medium text-gray-900  hover:bg-yellow-300"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="flex-auto flex justify-start md:order-2 md:pl-32 mb-20">
          <div className="text-center md:w-[50%]">
            <h1 className=" font-semibold text-[34px]  ">About SmallSmall</h1>
            <p className="">
              "To achieve anything great, start with small small steps" <br />{' '}
              Jeff Bezos
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutBanner;
